<template>
  <div class="module report-module" style="padding-bottom: 24px;" :id="moduleData.itemCode" v-loading="loading">
    <div class="module-label">报告要求</div>
    <el-form :class="{ 'cs-form': isCs }" :model="form" :rules="rules" ref="form" label-width="165px" label-position="right" v-if="formConfig.length">
      <el-row style="padding-right: 46px;">
        <el-col :span="8" v-if="configByCode.ReportLua">
          <!--     报告语言     -->
          <el-form-item :label="configByCode.ReportLua.attrName" class="is-required" prop="reportLuaCode">
            <el-select v-if="!isOiq" v-model="form.reportLuaCode" placeholder="请选择" :disabled="disabledAll" style="width: 100%;">
              <el-option v-for="item in configByCode.ReportLua.enums" :key="item.enumCode" :label="item.enumName" :value="item.enumCode">
              </el-option>
            </el-select>
            <el-input v-else disabled v-model="form.reportLuaValue"></el-input>
          </el-form-item>
        </el-col>
        <!--     报告形式     -->
        <el-col :span="8" v-if="configByCode.ReportForm">
          <el-form-item :label="configByCode.ReportForm.attrName" class="is-required" prop="reportFormCode">
            <el-select v-if="!isOiq" v-model="form.reportFormCode" placeholder="请选择" :disabled="disabledAll" style="width: 100%;">
              <el-option v-for="item in configByCode.ReportForm.enums" :key="item.enumCode" :label="item.enumName" :value="item.enumCode">
              </el-option>
            </el-select>
            <el-input v-else disabled v-model="form.reportFormValue"></el-input>
<!--            <el-tooltip class="item" effect="dark" content="如需要纸质报告或双语报告，增加费用以业务员实际报价为准。" placement="top">-->
<!--              <img class="item-tips" src="../../../assets/images/apply/tips.png" alt="">-->
<!--            </el-tooltip>-->
          </el-form-item>
        </el-col>
        <!--    报告抬头      -->
        <template v-if="configByCode.reportTitleType">
          <el-col :span="24">
            <el-form-item label="报告抬头" class="is-required reportTitleType" prop="reportTitleType">
              <el-radio-group v-model="form.reportTitleType" :disabled="disabledAll">
                <el-radio :label="0">申请方</el-radio>
                <el-radio :label="1">付款方</el-radio>
                <el-radio :label="2">其他抬头</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24" style="padding-left: 165px;" v-if="form.reportTitleType !== ''">
            <div class="report-form">
              <!--    公司名称      -->
              <div class="report-form-item">
                <div class="label">{{configByCode.otherCompanyNameCn.attrName}}：</div>
                <div class="content" v-if="form.reportTitleType === 0 || (form.reportTitleType === 1 && invoiceData.invoiceType !== 2)">
                  {{form.reportTitleType === 0 ? applyInfoData.companyNameCn : invoiceData.invoiceTitle}}
                </div>
                <el-form-item prop="reportCompanyNameCn" label-width="0" class="is-required" v-else>
                  <el-input :placeholder="configByCode.otherCompanyNameCn.fillNotice" v-model="form.reportCompanyNameCn" :maxlength="configByCode.otherCompanyNameCn.fillLen" :disabled="disabledAll"></el-input>
                </el-form-item>
              </div>
              <!--    公司地址      -->
              <div class="report-form-item">
                <div class="label">{{configByCode.otherCompanyAddressCn.attrName}}：</div>
                <div class="content" v-if="form.reportTitleType === 0 || (form.reportTitleType === 1 && invoiceData.invoiceType !== 2)">
                  {{form.reportTitleType === 0 ? applyInfoData.companyAddressCn : invoiceData.regAddress}}
                </div>
                <el-form-item prop="reportAddressCn" label-width="0" class="is-required" v-else>
                  <el-input :placeholder="configByCode.otherCompanyAddressCn.fillNotice" v-model="form.reportAddressCn" :maxlength="configByCode.otherCompanyAddressCn.fillLen" :disabled="disabledAll"></el-input>
                </el-form-item>
              </div>
              <!--    Company Name      -->
              <div class="report-form-item">
                <div class="label">{{configByCode.otherCompanyNameEn.attrName}}：</div>
                <div class="content" v-if="form.reportTitleType === 0">
                  {{applyInfoData.companyNameEn}}
                </div>
                <el-form-item prop="reportCompanyNameEn" label-width="0" :class="{ 'is-required': reportLuaCode && reportLuaCode !== 'ZN' }" v-else>
                  <el-input :placeholder="configByCode.otherCompanyNameEn.fillNotice" v-model="form.reportCompanyNameEn" :maxlength="configByCode.otherCompanyNameEn.fillLen" :disabled="disabledAll"></el-input>
                </el-form-item>
              </div>
              <!--    Company Address      -->
              <div class="report-form-item">
                <div class="label">{{configByCode.otherCompanyAddressEn.attrName}}：</div>
                <div class="content" v-if="form.reportTitleType === 0">
                  {{applyInfoData.companyAddressEn}}
                </div>
                <el-form-item prop="reportAddressEn" label-width="0" :class="{ 'is-required': reportLuaCode && reportLuaCode !== 'ZN' }" v-else>
                  <el-input :placeholder="configByCode.otherCompanyAddressEn.fillNotice" v-model="form.reportAddressEn" :maxlength="configByCode.otherCompanyAddressEn.fillLen" :disabled="disabledAll"></el-input>
                </el-form-item>
              </div>
            </div>
          </el-col>
        </template>
        <!--     报告出具要求     -->
        <el-col :span="24" v-if="configByCode.ReportMethod">
          <el-form-item :label="configByCode.ReportMethod.attrName" class="is-required reportMethod-item" prop="reportMethod">
            <el-radio-group v-model="form.reportMethod" :disabled="disabledAll">
              <el-radio v-for="item in configByCode.ReportMethod.enums" :key="item.enumCode" :label="Number(item.enumCode)">{{item.enumName}}</el-radio>
            </el-radio-group>
            <el-input :placeholder="configByCode.ReportMethod.fillNotice" :maxlength="configByCode.ReportMethod.fillLen" v-model="form.reportMethodMemo"
                      style="width: 320px;margin-left: 20px;"
                      v-if="form.reportMethod == 3"
                      :disabled="disabledAll" class="other_report"></el-input>
          </el-form-item>
        </el-col>
        <!--     报告邮寄地址     -->
        <el-col :span="24" v-if="configByCode.ReportAddressCn">
          <el-form-item :label="configByCode.ReportAddressCn.attrName" class="is-required" :class="{ 'no-error': reportAddressData.length }" prop="addressList" v-if="form.reportFormCode && form.reportFormCode != 2">
            <el-button class="common-btn" @click="openAddress('reportAddressData')" v-if="!reportAddressData.length" :disabled="disabledAll">+接收地址</el-button>
            <div v-for="(item, index) in reportAddressData" :key="index">
              <span>{{ item.userAddressDTO.province }} {{ item.userAddressDTO.city }} {{ item.userAddressDTO.town }}{{ item.userAddressDTO.companyAddress }}{{ item.userAddressDTO.companyName ? '，' + item.userAddressDTO.companyName : '，' }}</span>
              {{ item.userAddressDTO.userName }}，{{ item.userAddressDTO.userPhone }}
              <span class="edit-address-btn" @click="openAddress('reportAddressData', index)" v-if="!disabledAll">修改</span>
            </div>
          </el-form-item>
        </el-col>
        <!--     报告发送邮箱     -->
        <el-col :span="24" class="reportEmail" v-if="configByCode.ReportSendMail">
          <el-form-item :label="configByCode.ReportSendMail.attrName" :class="{'is-error': showAddEmailErr}">
            <span class="email-item" style="margin-right: 20px;">
              {{applyInfoData.linkEmail}}
              <template v-if="applyInfoData.linkEmail">（申请方）</template>
            </span>
            <span v-for="(item, index) in form.orderLinkList" :key="index" class="email-item">
                    {{ item.linkEmail }}
                    <el-button type="text" @click="delEmail(index)" class="del-email" v-if="!disabledAll">删除</el-button>
                  </span>
            <div class="add-email-input" v-show="isAddEmail">
              <div>
                <el-input v-model="currentEmail" @keyup.enter.native="saveEmail" ref="emailInput"
                          :maxlength="configByCode.ReportSendMail.fillLen"></el-input>
                <el-button type="primary" class="add-email" @click="saveEmail">保存</el-button>
                <el-button class="cancel-add" @click="isAddEmail = false">取消</el-button>
              </div>
              <div class="err-msg" v-if="showAddEmailErr">{{ errMsg }}</div>
            </div>
            <el-button class="common-btn" :disabled="disabledAll" @click="addEmail" v-if="!isAddEmail && !disabledAll && form.orderLinkList.length < 10">+接收邮箱</el-button>
          </el-form-item>
        </el-col>
        <!--     资质要求     -->
        <el-col :span="24" v-if="configByCode.qualifications">
          <el-form-item :label="configByCode.qualifications.attrName" prop="qualificationsArr">
            <el-checkbox-group v-model="form.qualificationsArr" :disabled="disabledAll">
              <el-checkbox v-for="item in configByCode.qualifications.enums" :key="item.enumCode" :label="item.enumCode">{{item.enumName}}</el-checkbox>
              <el-button class="common-btn" style="margin-left: 33px;" @click="dialogVisible = true">查看样品要求</el-button>
            </el-checkbox-group>
            <div class="form-bottom-tips" v-if="form.qualificationsArr.some(v => v === 'CNAS' || v === 'CMA')">如需要加盖CNAS、CMA章，请与销售经理沟通确认</div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template v-if="addressDialog && !disabledAll">
      <choose-address v-model="addressDialog" :currentData.sync="currentData" @updateData="updateAddressData"
                      @delAddress="delAddress" v-if="addressListShow" :apis="apis" @addAddress="toggleAddress" :userId="formInfo.orderBase.userId" :isCs="isCs"></choose-address>
      <CreateAddress :isAdd="isAdd" v-model="addressDialog" :data.sync="currentData" :apis="apis" @updateData="updateAddressData" v-else @showList="toggleAddress" :isCs="isCs" :hasUser="hasUser && !isCreate">
      </CreateAddress>
    </template>
    <el-dialog title="样品要求" :visible.sync="dialogVisible" width="900px" :before-close="handleClose" class="sample-requirements-dialog" :append-to-body="true">
      <div style="margin-bottom: 17px;">
        <span class="type-label">样品类型</span>
        <el-select v-model="sampleCategoryCode" placeholder="请选择" :disabled="disabledAll" style="width: 210px;" @change="categoryChange">
          <el-option v-for="item in category" :key="item.enumCode" :label="item.enumName" :value="item.enumCode">
          </el-option>
        </el-select>
      </div>
      <div style="text-align: center;">
        <img :src="sampleCategoryImg" alt="" style="max-width: 100%;">
      </div>

    </el-dialog>
  </div>
</template>

<script>
import {applyMixins} from "src/components/application/components/mixin";
import CreateAddress from "src/components/apply/CreateAddress.vue";
import ChooseAddress from "src/components/apply/ChooseAddress.vue";
import {emailReg} from "utils";
export default {
  name: "ReportInfo",
  mixins: [applyMixins],
  components: {
    CreateAddress,
    ChooseAddress
  },
  data() {
    return {
      form: {
        reportLuaCode: '',
        reportLuaValue: '',
        reportFormCode: '',
        reportFormValue: '',
        reportTitleType: '',
        reportCompanyNameCn: '',
        reportAddressCn: '',
        reportCompanyNameEn: '',
        reportAddressEn: '',
        reportMethod: '',
        reportMethodMemo: '',
        orderLinkList: [],
        addressList: [],
        qualifications: '',
        qualificationsArr: []
      },
      reportLuaList: [],
      reportFormList: [],
      reportMethodData: [],
      reportAddressData: [],
      currentEmail: '',
      isAddEmail: false,
      showAddEmailErr: false,
      errMsg: '',
      loading: false,
      credentialData: [],
      dialogVisible: false,
      category: [],
      sampleCategoryCode: '',
      sampleCategoryImg: '',
      configByCode: {}
    }
  },
  computed: {
    rules() {
      const validateMethod = (rule, value, callback) => {
        if (!this.isCs && this.isSave && value === 3 && !this.form.reportMethodMemo) {
          return callback(new Error('请输入报告出具要求'))
        } else {
          return callback()
        }
      }
      return {
        reportLuaCode: [this.required],
        reportFormCode: [this.required],
        reportTitleType: [this.required],
        reportCompanyNameCn: [this.required],
        reportAddressCn: [this.required],
        reportCompanyNameEn: [this.requiredEn],
        reportAddressEn: [this.requiredEn],
        reportMethod: [this.required, { validator: validateMethod }],
        addressList: [this.required],
      }
    }
  },
  watch: {
    formConfig: {
      handler(val) {
        if (!val.length) return
        const configObj = val.find(v => v.areaCode === 'ReportInfo') || {}
        const configArr = configObj.attrs || []
        this.configByCode = this.getFormConfigByCode(configArr)
        if (this.configByCode.qualifications) {
          const sampleConfigObj = val.find(v => v.areaCode === 'Sample') || {}
          const sampleCategory = this.getFormConfigByCode(sampleConfigObj.attrs || []).sampleCategory
          if (sampleCategory && sampleCategory.enums) {
            this.category = sampleCategory.enums.filter(v => v.enumExtend)
            this.sampleCategoryCode = this.category[0].enumCode
            this.sampleCategoryImg = this.category[0].enumExtend
          }
        }
      },
      immediate: true
    },
    'form.reportLuaCode': {
      handler(val) {
        this.$emit('update:reportLuaCode', val)
      }
    },
    formInfo: {
      handler(val) {
        if (val) {
          if (this.moduleData.sourceFormatJson) {
            this.form = this.formatByJson(val, this.moduleData.sourceFormatJson)
          } else {
            this.form = JSON.parse(JSON.stringify(val))
          }
          this.reportAddressData = [...this.form.addressList]
          const qualificationsArr = this.form.qualifications ? this.form.qualifications.split(',') : []
          this.$set(this.form, 'qualificationsArr', qualificationsArr)
        }
      },
      immediate: true
    },
    enumConfig: {
      handler(val) {
        if (val) {
          // const buInfo = this.buName ? this.buName.toUpperCase() + '_' : ''
          // this.reportLuaList = val[`ORDER_BASE_INFO.${buInfo}REPORT_LUA`]
          // this.reportFormList = val[`ORDER_BASE_INFO.${buInfo}REPORT_FORM`]
          // this.reportMethodData = val[`ORDER_REPORT.${buInfo}REPORT_METHOD`]
          // this.credentialData = val[`APPLICATION_FORM.LAB_QUALIFICATION`]
          // this.category = val[`ORDER_SAMPLE.${buInfo}SAMPLE_CATEGORY`].filter(v => v.enumExtend)
          // this.sampleCategoryCode = this.category[0].enumCode
          // this.sampleCategoryImg = this.category[0].enumExtend
        }
      },
      immediate: true
    }
  },
  created() {
  },
  methods: {
    checkEmail() {
      if (!emailReg.test(this.currentEmail)) {
        this.showAddEmailErr = true
        this.errMsg = '请输入正确的邮箱格式'
        return
      }
      if (this.form.orderLinkList.some(v => v.linkEmail === this.currentEmail)) {
        this.showAddEmailErr = true
        this.errMsg = '您已添加此邮箱'
        return
      }
      return true
    },
    categoryChange(val) {
      this.sampleCategoryImg = this.category.find(v => v.enumCode === val).enumExtend
    },
    handleClose() {
      this.dialogVisible = false
      this.sampleCategoryCode = this.category[0].enumCode
      this.sampleCategoryImg = this.category[0].enumExtend
    },
    getValidate() {
      let data = this.form
      data.addressList = this.reportAddressData
      data.qualifications = this.form.qualificationsArr.join(',')
      data.reportMethodMemo = data.reportMethod === 3 ? data.reportMethodMemo : ''
      if (this.moduleData.getFormatJson) {
        data = this.formatByJson(data, this.moduleData.getFormatJson)
      }
      this.$emit('input', JSON.parse(JSON.stringify(data)))
      return new Promise(resolve => this.$refs.form.validate(resolve))
    },
    delEmail(index) {
      this.form.orderLinkList.splice(index, 1)
    },
    saveEmail() {
      if (!this.checkEmail()) {
        return
      }
      this.form.orderLinkList.push({
        linkEmail: this.currentEmail
      })
      this.isAddEmail = false
      this.currentEmail = ''
      this.showAddEmailErr = false
      return true
    },
    addEmail() {
      this.currentEmail = ''
      this.isAddEmail = true
      this.showAddEmailErr = false
      this.$nextTick(() => {
        this.$refs.emailInput.focus()
      })
    }
  }
}
</script>


<style lang="scss" scoped>
.reportMethod-item {
  ::v-deep .el-form-item__content {
    display: flex;
    align-items: center;
  }
  ::v-deep .el-radio__label {
    line-height: 40px;
  }
}
</style>
<style lang="scss">
.sample-requirements-dialog {
  .type-label {
    color: rgb(51, 51, 51);
    font-size: 14px;
    line-height: 18px;
    margin-right: 23px;
  }
  .el-dialog {
    border-radius: 12px;
  }
  .el-dialog__header {
    border-bottom: 1px solid #E7E7E7;
  }
}
</style>